const TIMEZONES_BY_COUNTRY = {
  USA: {
    Eastern: 'America/New_York',
    Central: 'America/Chicago',
    Mountain: 'America/Denver',
    Pacific: 'America/Los_Angeles',
    Arizona: 'America/Phoenix',
    Alaska: 'America/Anchorage',
    Hawaii: 'Pacific/Honolulu'
  },
  AUS: {
    Eastern: 'Australia/Sydney',
    'Eastern (QLD)': 'Australia/Brisbane',
    'Central (SA)': 'Australia/Adelaide',
    'Central (NT)': 'Australia/Darwin',
    Western: 'Australia/Perth'
  },
  CAN: {
    Pacific: 'America/Vancouver',
    'Mountain (Yukon)': 'America/Whitehorse',
    Mountain: 'America/Edmonton',
    'Central (Saskatchewan)': 'America/Regina',
    Central: 'America/Winnipeg',
    Eastern: 'America/Toronto',
    Atlantic: 'America/Halifax',
    Newfoundland: 'America/St_Johns'
  },
  GBR: {
    Eastern: 'Europe/London',
    'Eastern (Scotland)': 'Europe/Edinburgh',
    'Eastern (Wales)': 'Europe/Cardiff',
    'Eastern (Northern Ireland)': 'Europe/Belfast'
  }
}

export function timezonesFor(country) {
  return TIMEZONES_BY_COUNTRY[String(country ?? '').trim()] ?? TIMEZONES_BY_COUNTRY.USA
}
